module.exports = __webpack_public_path__ + "static/media/dr-ramsay.b3bfda1a.jpg";